/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import { isMobile } from "react-device-detect";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import Event202304_uma_gamecode_show from "./Event202304_uma_gamecode_show";

import "../../css/event20230410.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "../../css/confirm.css";

class Event202304_uma_gamecode extends Component {
  state = {
    orderCode: "",
    showCode: false,
  };
  componentDidMount = () => {
    const { loginId, history } = this.props;

    if (loginId === null || loginId === undefined || loginId === "") {
      history.push("/login_ugc");
    } else {
      this._getOrderList();
    }
  };
  componentWillUnmount = () => {};

  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _getOrderList = async () => {
    const { loginId, pkg, apiUrl, history } = this.props;
    const at = localStorage.getItem("at");

    if (loginId === null || loginId === undefined || loginId === "") {
    } else {
      const result = await axios
        .post(
          apiUrl + "/event_uma_gamecode_buylist",
          {
            params: {
              userid: loginId,
              pkg: pkg,
            },
          },
          {
            headers: {
              Authorization: "bearer " + at,
            },
          }
        )
        .catch((error) => {
          console.error(error.response.status);
          if (error.response.status === 403) {
            //console.log('refresh....token...')
            this._refreshToken();
          } else if (error.response.status === 400) {
            history.push("/login");
          }
        });

      if (result) {
        const intReturn = result.data[0].intReturn;
        const buyList = result.data[0].listData;
        if (intReturn === 0) {
          this.setState({
            buyList,
          });
        }
      }
    }
  };
  _refreshToken = async () => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem("rt");

    if (rt === "" || rt === undefined || rt === null) {
      history.push("/login");
      return false;
    }

    const { data } = await axios.post(apiUrl + "/refreshToken", {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem("at", data[0].at);
      this._getOrderList();
    } else {
      this.setCookie("account", "");

      setLoginId("");
      setAuthId("");

      setTimeout(() => {
        history.push("/login");
      }, 500);
    }
  };
  _renderItem = () => {
    const { buyList, showCode, orderCode } = this.state;
    const list = buyList.map((item) => {
      return (
        <>
          <div className="d_flex">
            <table key={item.orderCode}>
              <caption></caption>
              <colgroup>
                <col style={{ width: "80%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>주문번호</th>
                  <th>수량</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{item.orderCode}</td>
                  <td>{item.goodCount}</td>
                </tr>
              </tbody>
            </table>

            <button
              className={item.chkConfirm === "Y" ? "btn_codeVE" : "btn_codeV"}
              onClick={() => this._confirm(item.chkConfirm, item.orderCode)}
            >
              {item.chkConfirm === "Y" ? "코드 발급완료" : "코드 확인하기"}
            </button>
          </div>
          {item.chkConfirm === "Y" && orderCode === item.orderCode ? (
            <Event202304_uma_gamecode_show orderCode={item.orderCode} />
          ) : null}
        </>
      );
    });

    return list;
  };
  _confirm = (chkConfirm, orderCode) => {
    if (chkConfirm === "N") {
      if (
        window.confirm(
          "게임코드를 확인하시면 구매상품의 환불은 불가합니다.\n\n게임코드를 확인 하시겠습니까?"
        )
      ) {
        this._checkCode(orderCode);
      }
      // confirmAlert({
      //   title:
      //     "게임코드를 확인하시면 구매상품의 환불은 불가합니다. 코드를 확인 하시겠습니까?",
      //   // message: "로그인 후 응모하실 수 있습니다.",
      //   buttons: [
      //     {
      //       label: "예",
      //       onClick: () => {
      //         this._checkCode(orderCode);
      //       },
      //     },
      //     {
      //       label: "아니오",
      //     },
      //   ],
      // });
    } else {
      this._checkCode(orderCode);
    }
  };
  _checkCode = async (orderCode) => {
    const { loginId, pkg, apiUrl, history } = this.props;
    const at = localStorage.getItem("at");

    if (loginId === null || loginId === undefined || loginId === "") {
    } else {
      const result = await axios
        .post(
          apiUrl + "/event_uma_gamecode_chkConfirm",
          {
            params: {
              userid: loginId,
              pkg: pkg,
              orderCode: orderCode,
            },
          },
          {
            headers: {
              Authorization: "bearer " + at,
            },
          }
        )
        .catch((error) => {
          console.error(error.response.status);
          if (error.response.status === 403) {
            //console.log('refresh....token...')
            this._refreshToken();
          } else if (error.response.status === 400) {
            history.push("/login");
          }
        });

      if (result) {
        const intReturn = result.data[0].intReturn;
        if (intReturn === 0 || intReturn === 1) {
          //게임코드 보여주기.
          this.setState({
            orderCode,
            showCode: true,
          });
          this._getOrderList();
        }
      }
    }
  };
  render() {
    const { imgUrl, loginId, nicName } = this.props;
    const { buyList, orderCode, showCode } = this.state;

    return (
      <Fragment>
        <div className="evt_wrap">
          <div className="evt_1">
            <img src="/img/event/event20230410/evt_11.png" alt="" />
          </div>
          <div className="codeView">
            <dl>
              <dt>닉네임</dt>
              <dd>{nicName}</dd>
              <dt style={{ marginLeft: 5 }}>ID</dt>
              <dd>{loginId}</dd>
            </dl>
            {buyList ? (
              <>
                {this._renderItem()}
                {/* {showCode ? (
                  <Event202304_uma_gamecode_show orderCode={orderCode} />
                ) : null} */}
              </>
            ) : (
              <div className="d_flex">
                <div
                  style={{
                    fontSize: 18,
                    textAlign: "center",
                    width: "100%",
                    paddingTop: 30,
                    color: "#ff5d24",
                  }}
                >
                  구매내역이 존재하지 않습니다.
                </div>
              </div>
            )}
          </div>
          <div className="evt_2">
            <img src="/img/event/event20230410/evt_2.png" alt="" />
          </div>
          <div className="evt_3">
            <img src="/img/event/event20230410/evt_3.png" alt="" />
          </div>
          <div className="evt_4">
            <img src="/img/event/event20230410/evt_4.png" alt="" />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202304_uma_gamecode));
